export type SegmentedToggleSize = 'sm' | 'md' | 'lg';
export type SegmentedToggleTone = 'default' | 'subtle';

export const SEGMENTED_TOGGLE_SIZE_STYLES: Record<
  SegmentedToggleSize,
  { shell: string; button: string; iconOnlyButton: string; label: string; icon: string; count: string }
> = {
  sm: {
    shell: 'min-h-9 p-0.5 gap-0.5',
    button: 'min-h-8 px-3 gap-1.5',
    iconOnlyButton: 'min-h-8 w-8 p-0',
    label: 'text-[11px] font-bold uppercase tracking-[0.08em]',
    icon: 'h-3 w-3',
    count: 'ml-1 rounded px-1 text-[10px] font-semibold',
  },
  md: {
    shell: 'min-h-10 p-0.5 gap-0.5',
    button: 'min-h-9 px-4 gap-2',
    iconOnlyButton: 'min-h-9 w-9 p-0',
    label: 'text-[11px] font-bold uppercase tracking-[0.08em]',
    icon: 'h-3.5 w-3.5',
    count: 'ml-1 rounded px-1 text-[10px] font-semibold',
  },
  lg: {
    shell: 'min-h-11 p-0.5 gap-0.5',
    button: 'min-h-10 px-4 gap-2',
    iconOnlyButton: 'min-h-10 w-10 p-0',
    label: 'text-[12px] font-bold uppercase tracking-[0.09em]',
    icon: 'h-4 w-4',
    count: 'ml-1.5 rounded px-1.5 text-overline',
  },
};

export const SEGMENTED_TOGGLE_TONE_STYLES: Record<
  SegmentedToggleTone,
  {
    shell: string;
    active: string;
    inactive: string;
    countActive: string;
    countInactive: string;
  }
> = {
  default: {
    shell:
      'border border-border/70 bg-background shadow-[var(--shadow-warm-sm)]',
    active:
      'bg-primary text-primary-foreground shadow-[var(--shadow-warm-sm)]',
    inactive:
      'bg-transparent text-muted-foreground hover:bg-muted/[0.08] hover:text-foreground',
    countActive: 'bg-primary-foreground/15 text-primary-foreground',
    countInactive: 'bg-muted/[0.7] text-muted-foreground',
  },
  subtle: {
    shell: 'border border-border/60 bg-muted/[0.05]',
    active: 'bg-card text-foreground shadow-[var(--shadow-warm-sm)]',
    inactive:
      'bg-transparent text-muted-foreground hover:bg-muted/[0.08] hover:text-foreground',
    countActive: 'bg-foreground/8 text-foreground',
    countInactive: 'bg-muted/[0.7] text-muted-foreground',
  },
};
